import React from 'react';

export default function PermissionManagement() {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Permission Management</h1>
      <p className="text-gray-500">Halaman Permission Management</p>
    </div>
  );
}
